// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__FoQT8","rootCenter":"LoadMoreObserver_rootCenter__3cr-Y","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__cIJTN"};